<div class="flex min-h-screen flex-col bg-rfy-background text-rfy-foreground">
    <app-topnav />
    @if (navegacao.layoutEfetivo() === 'horizontal' && navegacao.subnavVisivel()) { <app-horizontal-topnav /> }
    <div class="flex min-h-0 flex-1">
        @if (navegacao.layoutEfetivo() === 'vertical') { <app-sidenav /> }
        <main class="flex min-w-0 flex-1 flex-col">
            <div class="flex-1">
                <router-outlet />
            </div>
            <footer class="flex flex-wrap items-center justify-between gap-2 px-[1.5rem] py-[0.75rem] text-xs text-rfy-muted [border-top:1px_solid_var(--rfy-border)]">
                <span class="flex flex-wrap gap-1">
                    <a app-button cor="neutral" variante="ghost" tamanho="sm" target="_blank" rel="noopener" href="https://rematefy.com/site/">Site</a>
                    <a app-button cor="neutral" variante="ghost" tamanho="sm" target="_blank" rel="noopener" href="https://blog.rematefy.com">Blog</a>
                    <a app-button cor="neutral" variante="ghost" tamanho="sm" target="_blank" rel="noopener" [href]="urlApp">Web</a>
                </span>
                <span>&#64;Rematefy · versão {{ version.versao.atual }}</span>
            </footer>
        </main>
    </div>
    <app-right-config />

    @if (notificacao.mostrar) {
        <app-notificacao
            (fechou)="fechar()"
            [titulo]="notificacao.titulo"
            [mensagem]="notificacao.mensagem">
        </app-notificacao>
    }
</div>
